export const getPendingFileList = (state) => state.course.pendingFileList

export const getUploadedFileList = (state) => state.course.uploadedFileList

export const getProcessingFile = (state) => state.course.processingFile
